import * as Icons from "@mui/icons-material";
import {
  roleConstants as roles,
  subscriptionConstants as plans,
  hasSubscription,
} from "core/utils/roleUtils";

export const builderAdminMenu = [
  {
    id: "menu_alerts",
    label: "Alerts",
    link: "/alerts",
    icon: <Icons.NotificationImportant />,
  },
  {
    id: "menu_dashboard",
    label: "Dashboard",
    link: "/dashboard",
    icon: <Icons.Dashboard />,
    shouldHide: (profile) => hasSubscription(profile, plans.FREE_SUBSCRIPTION),
  },
  {
    id: "menu_properties",
    label: "Properties",
    link: "/properties",
    icon: <Icons.MapsHomeWorkOutlined />,

    // roles: [
    //  roles.BUILDER_ADMIN,
    //  roles.BUILDER_GENERAL_MANAGER,
    //  roles.BUILDER_PROJECT_MANAGER,
    // ],
  },
  {
    id: `menu_file_manager`,
    label: "File Manager",
    link: "/filemanager",
    icon: <Icons.FolderCopyOutlined />,
    roles: [
      roles.SYSTEM_ADMIN,
      roles.BUILDER_ADMIN,
      roles.BUILDER_GENERAL_MANAGER,
    ],
    shouldHide: (profile) => hasSubscription(profile, plans.FREE_SUBSCRIPTION),
  },
  {
    id: "menu_suppliers",
    label: "Suppliers",
    link: "/builder/connections",
    icon: <Icons.Diversity2Outlined />,
    roles: [roles.BUILDER_ADMIN, roles.BUILDER_GENERAL_MANAGER],
    // shouldHide: (profile) => hasSubscription(profile, plans.FREE_SUBSCRIPTION),
  },
  // {
  //   id: "menu_crm",
  //   label: "CRM",
  //   link: "builder/crm",
  //   icon: <Icons.Inventory2Outlined />,
  //   roles: [roles.BUILDER_ADMIN, roles.BUILDER_GENERAL_MANAGER],
  // },
  {
    id: "menu_users",
    label: "Users",
    link: "/users",
    icon: <Icons.GroupsOutlined />,
    roles: [roles.BUILDER_ADMIN, roles.BUILDER_GENERAL_MANAGER],
    // shouldHide: (profile) => hasSubscription(profile, plans.FREE_SUBSCRIPTION),
  },
  {
    id: "menu_estimates",
    label: "Estimates",
    link: "/builder/estimations",
    icon: <Icons.ApprovalOutlined />,
    roles: [roles.BUILDER_ADMIN, roles.BUILDER_GENERAL_MANAGER],
    shouldHide: (profile) => hasSubscription(profile, plans.FREE_SUBSCRIPTION),
  },
  // {
  //   id: "menu_reports",
  //   label: "Reports",
  //   link: "/reports",
  //   icon: <Icons.Summarize />,
  //   roles: [roles.BUILDER_ADMIN, roles.BUILDER_GENERAL_MANAGER],
  //   shouldHide: (profile) => hasSubscription(profile, plans.FREE_SUBSCRIPTION),
  // },
  // {
  //   id: "menu_financials",
  //   label: "Financials",
  //   link: "/builder/financials",
  //   icon: <Icons.PaidOutlined />,
  //   roles: [roles.BUILDER_ADMIN, roles.BUILDER_GENERAL_MANAGER],
  //   shouldHide: (profile) => hasSubscription(profile, plans.FREE_SUBSCRIPTION),
  // },
  // {
  //   id: "menu_change_order",
  //   label: "Change Orders",
  //   link: "/changeOrders",
  //   icon: <Icons.CompareArrowsOutlined />,
  //   roles: [roles.BUILDER_ADMIN, roles.BUILDER_GENERAL_MANAGER],
  //   shouldHide: (profile) => hasSubscription(profile, plans.FREE_SUBSCRIPTION),
  // },
  {
    id: "menu_settings",
    label: "Settings",
    link: "/settings",
    icon: <Icons.SettingsOutlined />,
    roles: [roles.BUILDER_ADMIN, roles.BUILDER_GENERAL_MANAGER],
  },

  // {
  //   id: "menu_timelines",
  //   label: "Timelines",
  //   link: "/timelines",
  //   icon: <Icons.TimelineOutlined />,
  //   roles: [roles.BUILDER_ADMIN, roles.BUILDER_GENERAL_MANAGER],
  // },
  {
    id: "menu_timesheets",
    label: "TimeSheets",
    link: "/timesheet",
    icon: <Icons.PunchClockOutlined />,
  },

  {
    id: "menu_signout",
    label: "Signout",
    link: "/login",
    hiddenOn: { mdUp: true },
    icon: <Icons.LogoutOutlined />,
    onClick: () => {
      localStorage.removeItem("token");
    },
  },
];
